class SaleCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Event and time-related attributes
    this.startDate = parseInt(this.getAttribute('data-progress-start-date')); // Event start
    this.currentDate = parseInt(this.getAttribute('data-start-date'));       // Current time
    this.endDate = parseInt(this.getAttribute('data-end-date'));             // Event end

    // Fetch the initial start percentage from the [data-progress-percent] element, or use default 91%
    const progressElement = this.querySelectorAll('[data-progress-percent]');
    this.startPercent = progressElement[0] ? parseFloat(progressElement[0].textContent.trim()) : 91;
    this.targetPercent = 99.99;     // Ending percentage

    // Calculate the total event duration in seconds
    this.totalDurationInSeconds = this.endDate - this.startDate;

    // Calculate the progress rate per second
    this.progressPerSecond = (this.targetPercent - this.startPercent) / this.totalDurationInSeconds;

    this.updateCountdown(); // Initial update
    this.intervalId = setInterval(() => this.updateCountdown(), 1000); // Update every second
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }

  calculateRemainingTime() {
    const differenceInSeconds = this.endDate - this.currentDate;

    if (differenceInSeconds <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(differenceInSeconds / (3600 * 24));
    const hours = Math.floor((differenceInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((differenceInSeconds % 3600) / 60);
    const seconds = differenceInSeconds % 60;

    return { days, hours, minutes, seconds };
  }

  calculateProgressPercent() {
    const elapsedSeconds = this.currentDate - this.startDate;

    // If the elapsed time is less than or equal to 0, we are at the start percentage
    if (elapsedSeconds <= 0) return this.startPercent;

    // Calculate the progress percentage based on the elapsed time
    let progressPercent = this.startPercent + elapsedSeconds * this.progressPerSecond;
    console.log("CALCULATE PROGRESS");
    console.log(this.startPercent  + " : " + elapsedSeconds)
    // Cap the progress at the target percentage
    return Math.min(progressPercent, this.targetPercent).toFixed(1);
  }

  updateCountdown() {
    const remainingTime = this.calculateRemainingTime();
    const progressPercent = this.calculateProgressPercent();

    // Update countdown timers
    this.querySelector('.sale-countdown__days').textContent = remainingTime.days;
    this.querySelector('.sale-countdown__hours').textContent = remainingTime.hours;
    this.querySelector('.sale-countdown__min').textContent = remainingTime.minutes;
    this.querySelector('.sale-countdown__secs').textContent = remainingTime.seconds;

    // Update progress percentage
    if (this.querySelector('.sale-countdown__range')) {
       this.querySelector('.sale-countdown__range').style.setProperty('--sale-percentage', `${progressPercent}%`);
      const progressElement = this.querySelector('[data-progress-percent]');
      if (progressElement) {
        progressElement.textContent = `${progressPercent}%`;
      }
    }


    // Increment current time by 1 second for the next calculation
    this.currentDate += 1;
  }
}

customElements.define('sale-countdown', SaleCountdown);

function detectAndRemoveClass() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const element = document.querySelector('.js-android-ios-only');

  if (element) {
      if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
          element.classList.remove('js-android-ios-only');
      } else {
      }
  } else {
  }
}

document.addEventListener("DOMContentLoaded", detectAndRemoveClass);

if (!customElements.get('spin-to-win')) {
  customElements.define('spin-to-win', class extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.startButton = this.querySelector(".spin-to-win__start-button");
      this.stopButton = this.querySelector(".spin-to-win__stop-button");
      this.wheel = this.querySelector(".icon-spin-to-win");
      this.klaviyoForm = this.querySelector(".klaviyo-embed__container");
      this.testMessage = this.querySelector(".test-message");
      this.backgroundGift = this.getAttribute("background");
      this.postScript = this.querySelector(".spin-to-win__postscript")
      this.header = this.querySelector(".spin-to-win__header");
      this.spinModal = document.querySelector(".spin-modal");
      this.spinInterval;
      this.animationFrame;
      this.speed = 10;
      this.maxSpeed = 20;
      this.angle = 0;
      this.stop = false;
      this.init();
    }

    init() {
      this.startButton.addEventListener("click", () => {
        this.container.classList.add("step-2");
        this.spinStart();
        console.log("test");
        console.log(this.startButton.querySelector('svg'))
        if (this.startButton.querySelector('svg') != undefined && this.klaviyoForm.querySelector('button') != undefined) {
          console.log("add svg")
          const sourceSvg = this.startButton.querySelector('svg');
          const clone = sourceSvg.cloneNode(true);
          const clone2 = sourceSvg.cloneNode(true);
          this.klaviyoForm.querySelector('button').prepend(clone);
          this.klaviyoForm.querySelector('button').append(clone2);
        }
      });

      if (this.klaviyoForm != undefined) {
        console.log("observe klaviyo")
        
        this.observer = new MutationObserver(this.handleMutation.bind(this));
        this.observer.observe(this.klaviyoForm, {
          subtree: true,
          childList: true,
        });
      }

      if (this.postScript != undefined) {
        this.postScript.querySelector("form").addEventListener("submit",() => {
          console.log("Post script submitted")
          this.postScript.classList.add("hidden");
          this.container.classList.remove("step-2");
          this.container.classList.add("step-3");
          this.klaviyoForm.style.display = "block";
          this.spinModal.classList.add("final-step");
          this.spinModal.addEventListener("click", () => {
            this.spinModal.removeAttribute("open");
          })
          setTimeout(() => {
            if (this.startButton.querySelector('svg') != undefined && this.klaviyoForm.querySelector('button') != undefined) {
              console.log("add svg")
              const sourceSvg = this.startButton.querySelector('svg');
              const clone = sourceSvg.cloneNode(true);
              const clone2 = sourceSvg.cloneNode(true);
              this.klaviyoForm.querySelector('button').prepend(clone);
              this.klaviyoForm.querySelector('button').append(clone2);
            }
          }, 100)
          // fetch(`/discount/${this.dataset.discount}`, { method: "GET" }).then(() => {
          //   this.setCookie("free-gift", this.dataset.gift);
          //   let addOnSwitch = document.querySelector(`[data-product-id="${this.dataset.gift}"]`);
          //   if (addOnSwitch != undefined) {
          //     let priceParent = addOnSwitch.closest(".bundle-cards__add-on").querySelector(".bundle-cards__add-on-price");
          //     priceParent.classList.add("bundle-cards__card-upsell-price");
          //     priceParent.querySelector(".money").classList.add("bundle-cards__card-compare-price");
          //     priceParent.innerHTML += '<div class="bundle-cards__card-regular-price"><span class="money bold">FREE</span></div>';
          //   }
          // });
        })
      }

      setTimeout(() => {
        if (this.backgroundGift != undefined) {
          this.closest(".drawer").querySelector('[part="overlay"]').style.background = this.backgroundGift.replace("600x", window.innerWidth + "x");
        }
      }, 2500)
      setTimeout(() => {
      }, 4000)
    }

    enableFreeGift() {
      if (this.dataset.gift != undefined) {
        this.setCookie("free-gift", this.dataset.gift, 1209600);
        let addOnSwitch = document.querySelector(`[data-product-id="${this.dataset.gift}"]`);
        console.log("CHECK THE INBOX")
        console.log(addOnSwitch)
        if (addOnSwitch != undefined) {
          addOnSwitch.checked = true;
          addOnSwitch.dispatchEvent(new Event("change"));
        }
      }
    }

    spinAnimation() {
      this.speed = Math.min(this.speed * 1.05, this.maxSpeed);
      this.angle = (this.angle + this.speed) % 360;
      this.wheel.style.transform = `rotate(${this.angle}deg)`;
      this.animationFrame = requestAnimationFrame(this.spinAnimation.bind(this));
    }

    slowDown() {
      this.speed *= 0.95;
      this.angle += this.speed;
      this.wheel.style.transform = `rotate(${this.angle}deg)`;
      if (this.speed > 0.2) {
        this.animationFrame = requestAnimationFrame(this.slowDown.bind(this));
      } else {
        setTimeout(() => {
          this.wheel.closest(".spin-to-win__wheel").style.display = "none";
          
          this.querySelector('.icon-spin-to-win-triangle').style.display = "none";
          if (this.postScript != undefined) {
            this.postScript.classList.remove("hidden");
          } else {
            this.header.style.display = "none";
            this.klaviyoForm.style.display = "block";
            this.klaviyoForm.style.border = "none";
          }
        }, 600);
        
      }
    }

    // Helper: read current rotation in degrees (handles matrix & matrix3d)
    getCurrentAngle() {
      const t = getComputedStyle(this.wheel).transform;
      if (!t || t === 'none') return 0;

      // matrix(a, b, c, d, e, f)
      if (t.startsWith('matrix(')) {
        const m = t.match(/matrix\(([^)]+)\)/)[1].split(',').map(parseFloat);
        const a = m[0], b = m[1];
        return Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      // matrix3d(m11, m12, m13, ...):
      if (t.startsWith('matrix3d(')) {
        const m = t.match(/matrix3d\(([^)]+)\)/)[1].split(',').map(parseFloat);
        const a = m[0], b = m[1]; // same as 2D plane
        return Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      return 0;
    }
    
    // Lighter/smoother spin start
    spinStart() {
      if (this.spinning) return;

      // Prep
      this.spinning = true;
      this.wheel.classList.remove('idle');
      this.wheel.style.willChange = 'transform';

      // Read (before writes)
      const currentAngle = this.getCurrentAngle();
      this.currentAngle = currentAngle; // cache for future steps if needed

      // Write initial state
      this.wheel.style.transition = 'none';
      this.wheel.style.transform = `rotate(${currentAngle}deg)`;

      // Next frame: apply the “nudge” transition
      const startNudge = () => {
        // Use a gentle curve; a bit shorter for mobile responsiveness
        this.wheel.style.transition = 'transform 320ms cubic-bezier(.2,.6,.2,1)';
        this.wheel.style.transform = `rotate(${currentAngle - 60}deg)`;

        const onEnd = () => {
          this.wheel.removeEventListener('transitionend', onEnd);
          // Clear transition for the continuous spin loop
          this.wheel.style.transition = 'none';
          this.wheel.style.willChange = '';

          // Respect reduced motion
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            // If you want, you can short-circuit here or do a minimal update:
            // return;
          }

          // Hand off to your existing rAF-driven spinAnimation
          this.animationFrame = requestAnimationFrame(() => this.spinAnimation());
        };

        this.wheel.addEventListener('transitionend', onEnd, { once: true });
      };

      // Double-rAF ensures style is committed before transitioning (smoother on mobile GPUs)
      requestAnimationFrame(() => requestAnimationFrame(startNudge));
    }


    spinStop() {
      cancelAnimationFrame(this.animationFrame);
      console.log("SPIN STOP");
      this.enableFreeGift();
      this.animationFrame = requestAnimationFrame(this.slowDown.bind(this));
    }

    handleMutation(mutations) {
      console.log("has change")
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          console.log(mutation)
            mutation.removedNodes.forEach((node) => {
              console.log(node)
              
              console.log(node.tagName.toLowerCase() + " : " + node.className?.toString())
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'input') {
                    this.spinStop();
                    this.klaviyoForm.style.display = "none";
                    
                    this.spinning = false;
                }
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'div' && (node.id?.includes("form") || node.className?.toString().includes("form"))) {
                    this.spinStop();
                    this.klaviyoForm.style.display = "none";
                    
                    this.spinning = false;
                }
                if (node.nodeType === 3 && node.textContent?.includes("stop the wheel")) {
                  this.spinStop();
                  this.klaviyoForm.style.display = "none";
                  this.spinning = false;
                  return;
                }

                if (
                  node.nodeType === 1 &&
                  node.textContent?.toLowerCase().includes("stop the wheel")
                ) {
                  
                  this.spinStop();
                  if (this.postScript != undefined) {
                    this.klaviyoForm.style.display = "none";
                  } else {
                    this.spinModal.classList.add("final-step");
                  }
                  return;
                }
                if (node.nodeType === 1 && node.tagName.toLowerCase() === 'form') {
                  this.closest("x-drawer").removeAttribute("open");
                }
            });
        }
      });
    }
    setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  })
}
